// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"4fd8772b","500":"1bae2444","663":"4cc5d788"}[chunkId] + ".chunk.css";
};